<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="localVisible"
      width="50%"
      :before-close="handleClose"
    >
      <el-form label-width="110px" :inline="true" size="mini">
            <el-form-item label="POS名称" prop="car_number">
              <el-input v-model="keywords"/>
            </el-form-item>
           <el-form-item>
            <el-button @click="chooseItem">查询</el-button>
            </el-form-item>
      </el-form>
      <div>
        <el-table
          ref="multipleTable"
          :data="mList"
          height="300"
          stripe
          border
          size="mini"
          :header-cell-style="{background:'#e5e5e5',color:'#333333'}"
        >
           <el-table-column label="" width="50" align="center">
            <template slot-scope="scope">
              <el-radio v-model="curShop" :label="scope.row" @input="clickChange(scope.row)">{{ "" }}</el-radio>
            </template>
          </el-table-column>
          <el-table-column
            label="POS编号"
            width="105"
            prop="name_cn"
            :show-overflow-tooltip='true'
          >
          </el-table-column>
          <el-table-column
            label="POS名称"
            width="105"
            prop="name_cn"
            :show-overflow-tooltip='true'
          >
          </el-table-column>
          <el-table-column
            label="状态"
            width="105"
            prop="name_cn"
            :show-overflow-tooltip='true'
          >
          </el-table-column>
          <el-table-column
            label="创建时间"
            width="105"
            prop="name_cn"
            :show-overflow-tooltip='true'
          >
          </el-table-column>
          <el-table-column
            label="操作"
            prop="name_cn"
            :show-overflow-tooltip='true'
          >
          </el-table-column>
        </el-table>
        <el-row style="padding-top: 10px;display:flex;flex-direction: row;justify-content:space-between;">
          <el-col style="padding-top: 10px;">
            <el-button  size="mini" type="primary" @click="addPos">新增POS</el-button>
          </el-col>
          <el-col style="padding-top: 10px;display:flex;flex-direction: row;justify-content: flex-end;">
            <el-button size="mini" @click="close">取消</el-button>
            <el-button  size="mini" type="primary" @click="ok">确定</el-button>
          </el-col>
        </el-row>

      </div>
      <!--POS新增编辑 -->
      <el-dialog
        :title="title1"
        :visible="visible1"
        width="50%"
        center="true"
        :before-close="handleClose1"
        append-to-body
      >
        <el-form label-width="110px" :inline="true" size="mini">
          <el-form-item label="POS名称" prop="car_number">
            <el-input v-model="keywords"/>
          </el-form-item>
          <el-form-item label="状态" prop="car_number">
            <el-input v-model="keywords"/>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="visible1 = false">取 消</el-button>
          <el-button size="mini" type="primary" >提交</el-button>
        </div>
      </el-dialog>
      <!--POS新增编辑--->
    </el-dialog>


  </div>
</template>
<script>
  export default {
    name:'ePosList',
    props: {
      visible: {
        type: Boolean,
        default: true,
      },
      formData: {
        type: Object,
        default: null,
      },
      title: {
        type: String,
        default: "",
      },
      closeForm: Function,
    }
    ,
    data(){
      return {
        localVisible:false,
        title1:'',
        visible1:false,
        curShop:'',
        employee_id:'',
        name_cn:'',
        keywords:'',
        fileList:[],
        mList:[],
        pageNum:1,
        pageSize:10
      }
    },
    mounted() {
      this.getList();
    },
    methods:{
      addPos(){
        this.visible1=true;
        this.title1="新增POS";

      },
      handleClose(){

      },
      handleClose1(){
        this.visible1=false;
      },
      onClose(){
        this.$emit('update:employeeVisibleProp',false)
      },
      close(){
        this.$emit('update:employeeVisibleProp',false)
      },
      ok(){
        this.$emit('eventEmployee',this.employee_id,this.name_cn,33333);
        this.$emit('update:employeeVisibleProp',false)
      },
      getList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        this.$axios.employeeList(param).then(res=>{
          if(res.code == 200){
            this.mList = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      clickChange(row){
        this.employee_id=row.id;
        this.name_cn=row.name_cn;
        console.log('row----',row);
      },
      handleBeforeUpload(){

      },
      uploadSuccess(){

      },
      uploadFile(){

      },
      chooseItem(){

      }
    }
  }
</script>
<style lang="less" scoped>
  .upload_group {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .upload_list {
      width: 120px;
      margin-right: 1rem;
    }

    /deep/.el-upload-dragger .el-upload__text {
      font-size: 10px;
      color: #409EFF;
    }

    /deep/.el-icon-upload:before {
      width: 40px !important;
      height: 40px !important;
    }

    .upload_list:last-child {
      margin-right: 0;
    }

    /deep/.el-upload-dragger {
      width: 100%;
      height: auto;
      padding: 20px 0;
      border: 1px solid #999;
    }

    /deep/.el-upload {
      width: 100%;
    }

    /deep/.el-upload-dragger .el-icon-upload {
      margin: 10px 0;
    }
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }
</style>
